import React from "react";
import { Box } from "@mui/material";

/**
 * Pro 标签组件
 * 用于在 AnalyticsTabs、会员相关等位置展示 Pro 标识
 */
import type { SxProps, Theme } from "@mui/material";

export default function ProTag({ text, sx }: { text?: string, sx?: SxProps<Theme> }) {
  return (
    <Box
      component="span"
      sx={{
        display: "inline-block",
        color: "#FFF",
        fontSize: "0.75rem",
        fontWeight: 600,
        borderRadius: "0.3125rem",
        px: 0.5,
        py: 0.125,
        mr: 0.4,
        background:
          "linear-gradient(92deg, var(--Color-Gold-200, #E7C5A1) 0.76%, var(--Color-Gold-500, #A27D49) 99.24%)",
        ...sx, // 允许传入自定义样式
      }}
    >
      { text || "Pro" }
    </Box>
  );
}
